import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/not-authorized')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_auth/not-authorized"!</div>
}
